module.exports = __webpack_public_path__ + "img/bodhitree.6dd613da.jpg";